import { Observable } from 'rxjs';

/** 8-byte magic header: "IFPROJ" + version 0x01 + reserved 0x00 */
export const IFPROJ_MAGIC = new Uint8Array([0x49, 0x46, 0x50, 0x52, 0x4F, 0x4A, 0x01, 0x00]);
export const IFPROJ_MAGIC_LENGTH = 8;
export const IFPROJ_VERSION = '1.0';

export interface IFProjManifestFile {
  path: string;
  size: number;
  role: 'original' | 'proto' | 'config_xml' | 'image' | 'result_organic' | 'result_parametric' | 'result_parametric_alt' | 'result_jaw_left' | 'result_jaw_right' | 'result_part_transformed' | 'sketches' | 'report';
}

export interface IFProjManifest {
  version: string;
  platform: 'infinitform';
  exportedAt: string;
  exportedFrom: 'cloud' | 'desktop';
  project: {
    name: string;
    projectType: string;
    config: Record<string, unknown>;
    flowVersion: number;
    status: number;
    created_at: string;
    updated_at: string;
  };
  files: IFProjManifestFile[];
}

export interface ExportProgress {
  phase: 'preparing' | 'packaging' | 'uploading' | 'complete' | 'error';
  percent: number;
  message: string;
  downloadUrl?: string;
}

export interface ImportProgress {
  phase: 'validating' | 'extracting' | 'creating' | 'complete' | 'error';
  percent: number;
  message: string;
}

export interface IProjectExportImportService {
  exportProject(projectId: string, savePath?: string, options?: { includeHardware?: boolean }): Observable<ExportProgress>;
  /**
   * `targetUserId` (admin-only): when set, the imported project is owned by
   * the given user instead of the calling admin. Ignored on desktop (no
   * multi-user concept) and silently ignored on cloud for non-admin callers.
   */
  importProject(filePath: string, categoryId?: string, targetUserId?: string): Observable<ImportProgress>;
  readManifest(filePath: string): Observable<IFProjManifest>;
  validateFile(filePath: string): Observable<boolean>;
  pickExportPath(projectName: string): Observable<string | null>;
  pickImportFile(): Observable<string | null>;
}
